<template>
  <div class="workFlowContainer">
    <van-nav-bar
      :title="formname"
      left-text
      :left-arrow="!($route.query.formoutSize == '1')"
      @click-left="onClickLeft"
      :fixed="true"
    >
      <template #right v-if="can_export_app_screen">
        <span
          style="
            color: #fff;
            padding: 1px 10px;
            border: 1px solid #fff;
            border-radius: 5px;
          "
          @click="daoChu"
        >
          <svg-icon icon-class="xiazaidtb"></svg-icon>
          导出
        </span>
      </template>
    </van-nav-bar>
    <div class="workFlowIndexBox" id="workFlowIndexId">
      <BasicInfo
        :daoChuIng="daoChuIng"
        @returnPage="onClickLeft"
        @configFromEvent="configFromEvent"
      ></BasicInfo>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
// 主表信息
import { Toast, Dialog, Notify, ImagePreview } from "vant";
import BasicInfo from "./BasicInfo.vue";
import { allClose } from "@/utils/";
export default {
  name: "ApprovalFlow",
  // data函数返回一个对象，这个对象的属性会被绑定到模板上
  data() {
    return {
      daoChuIng: false,
      configForminfo: {},
      can_export_app_screen: false,
    };
  },
  components: {
    BasicInfo,
  },
  //  methods函数返回一个对象，这个对象的属性和方法会被绑定到模板上
  methods: {
    onClickLeft() {
      const fromPage = this.$route.query.fromPage;
      // commHrQueryPageSetRouteData
      if (fromPage == "home") {
        this.$router.push("/home").catch((err) => {
          console.log(err);
        });
      } else if (fromPage == "goback") {
        try {
          window.top.location.replace(document.referrer);
        } catch (error) {
          this.$router.push({
            path: "/wfList",
            query: { type: 1, formautoid: 0 },
          });
        }
      } else if (fromPage == "close") {
        try {
          allClose();
        } catch (error) {
          this.$router.push({
            path: "/wfList",
            query: { type: 1, formautoid: 0 },
          });
        }
      } else if (fromPage == "commHrQueryPage") {
        let queryObj = sessionStorage.getItem("commHrQueryPageSetRouteData")
          ? JSON.parse(sessionStorage.getItem("commHrQueryPageSetRouteData"))
          : {};
        this.$router.push({
          path: "/commHrQueryPage",
          query: queryObj,
        });
      } else if (this.new_saveormodify == "save") {
        if (this.$route.query.formoutSize == "1") {
          // 外部人员打开系统，需要直接关闭页面
          Notify({
            type: "success",
            message: "提交成功！",
            onClose: allClose(),
          });
        } else {
          this.$router.push({
            path: "/apply",
          });
        }
      } else if (fromPage == "wfList") {
        this.$router.push({
          path: "/wfList",
          query: { type: 1, formautoid: 0 },
        });
      } else {
        let queryObj = localStorage.getItem("RouterQueryObj")
          ? JSON.parse(localStorage.getItem("RouterQueryObj"))
          : { type: 1, formautoid: 0 };
        this.$router.push({
          path: "/wfList",
          query: queryObj,
        });
      }
    },
    daoChu() {
      this.daoChuIng = true;
      const loading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "导出中...",
      });
      setTimeout(() => {
        // 用canvas截取简历原图
        let imgData = "";
        const dom = document.getElementById("workFlowIndexId");
        const _this = this;
        html2canvas(dom).then(function (canvas) {
          _this.daoChuIng = false;
          loading.clear();
          imgData = canvas.toDataURL("image/jpeg");

          var ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            ImagePreview([imgData]);
          } else {
            let a = document.createElement("a"); // 生成一个a元素
            document.body.appendChild(a); //将a追加到页面上
            let event = new MouseEvent("click"); // 创建一个单击事件
            a.download = "流程图.png";
            a.href = imgData; // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件
            document.body.removeChild(a); // 完之后删除
          }
        });
      }, 30);
    },
    configFromEvent(config) {
      console.log(config, "configFromEvent;");
      this.configForminfo = config.forminfo[0];
      this.can_export_app_screen = config.forminfo[0].can_export_app_screen;
    },
  },
  // computed函数返回一个对象，这个对象的属性会被绑定到模板上
  computed: {
    formname() {
      return this.$route.query.formname;
    },
    formautoid() {
      return this.$route.query.formautoid;
    },
    mautoid: {
      get: function () {
        return this.$route.query.mautoid;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    nodeid() {
      return this.$route.query.nodeid;
    },
    new_saveormodify() {
      return this.$route.query.saveormodify;
    },
  },
  // watch函数返回一个对象，这个对象的属性和方法会被绑定到模板上
  watch: {
    formautoid: {
      handler(n) {
        if (n) {
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.workFlowContainer {
  .van-nav-bar {
    background: #2b8df0;
    z-index: 99;
    /deep/.van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .workFlowIndexBox {
    margin-top: 1.22667rem;
  }
}
</style>
